import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../css/Forgotpassword.css';
import { forgotPassword } from '../../api/api';
import CustomAlert from '../../components/CustomAlert';
import { useTranslation } from '../../hooks/useTranslation';
import Footer from '../../components/Footer';

const Forgotpassword = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const t = useTranslation();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');

    try {
      const res = await forgotPassword(email);
      CustomAlert.success(t('success'), t(res.message));
    } catch (err) {
      const msgKey = (typeof err === 'object' ? err?.message : err) || 'something_went_wrong';
      setError(t(msgKey));
    }
  };

  return (
    <div
      className="login-container"
      style={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        justifyContent: 'space-between',
      }}
    >
      <div
        style={{
          flex: '1 0 auto',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
          width: '100%',
        }}
      >
        <div className="login-wrapper">
          <div className="login-image">
            <img src="../../img/RocketBPM_rocket_logo.png" alt="Logo" className="login-logo" />
          </div>
          <h2>{t('forgot_your_password')}</h2>

          <form onSubmit={handleSubmit} className="login-form">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder={t('Email')}
              className="login-input"
            />
            {message && <p style={{ color: 'green' }}>{message}</p>}
            {error && <p style={{ color: 'red' }}>{error}</p>}

            <button type="submit" className="login-button">
              {t('reset')}
            </button>
            <p>
              {t('already_a_member')}
              <button className="btn_form" type="button" onClick={() => navigate('/login')}>
                {t('sign_in')}
              </button>
            </p>
          </form>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Forgotpassword;
